import { render, staticRenderFns } from "./recursiveMenu.vue?vue&type=template&id=ab9cea2c&scoped=true"
import script from "./recursiveMenu.vue?vue&type=script&lang=js"
export * from "./recursiveMenu.vue?vue&type=script&lang=js"
import style0 from "./recursiveMenu.vue?vue&type=style&index=0&id=ab9cea2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9cea2c",
  null
  
)

export default component.exports